'use client';

import { useContext } from 'react';
import noop from 'lodash/noop';
import { AppUiThemeContext } from './AppUiThemeContext';
import type { UseAppUiThemeReturnValues } from './types';

/**
 * @description default context for the useAppUiTheme hook
 */
const defaultContext: UseAppUiThemeReturnValues = {
  setAppUiTheme: noop,
  setAppUiDensity: noop,
  setAppUiSizing: noop,
};

/**
 * @description Custom hook to access the app's current theme state and update its theme
 */
export const useAppUiTheme = (): UseAppUiThemeReturnValues =>
  useContext(AppUiThemeContext) ?? defaultContext;
